export default __webpack_public_path__ + "static/media/Syed_Talha_Asad.4d9366af.png";